import { render, staticRenderFns } from "./PhoneStatus.vue?vue&type=template&id=db25c6a2"
import script from "./PhoneStatus.vue?vue&type=script&lang=js"
export * from "./PhoneStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports